export default "__VITE_ASSET__BmKBhAKD__"